// extracted by mini-css-extract-plugin
module.exports = {"icon":"dropdown-down-icon_icon__QqiLM"};